import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  BranchComponent,
  RegionComponent,
  DistrictComponent,
  GeographyService,
} from './index';
import { CoreModule } from './../core/core.module';
import { TrialGuardService } from '../core';
import { SavedViewsComponent } from '@/app/modules/saved-views/saved-views/saved-views.component';
import { FillRemainingHeightDirective } from '@/app/core/view/fill-remaining-height/fill-remaining-height.directive';
import { FeatureFlagModule } from '@/app/core/feature-flags/feature-flag.module';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'districts',
        component: DistrictComponent,
        data: { title: 'main.tabs.geography.districts.page_title' },
        canActivate: [TrialGuardService],
      },
      {
        path: 'regions',
        component: RegionComponent,
        data: { title: 'main.tabs.geography.regions.page_title' },
        canActivate: [TrialGuardService],
      },
      {
        path: 'branches',
        component: BranchComponent,
        data: { title: 'main.tabs.geography.branches.page_title' },
        canActivate: [TrialGuardService],
      },
    ]),
    CommonModule,
    CoreModule,
    SavedViewsComponent,
    // These are already imported in CoreModule
    // TableModule,
    // MultiSelectModule,
    // PaginatorModule,
    FillRemainingHeightDirective,
    FeatureFlagModule,
  ],
  providers: [GeographyService, TrialGuardService],
  declarations: [RegionComponent, BranchComponent, DistrictComponent],
})
export class GeographyModule {}
